import React from 'react';

const GalleryImg = ({ cardInfo }) => {
    return (
        <div className="col-md-6  col-lg-4" >
            <div className="card  gallery-card text-white">
                <div>
                    <img src={cardInfo?.new_img?.url} className="card-img" alt="..."></img>
                </div>
                <div className="px-2 img-overlay-text">
                    <ul>
                       {cardInfo?.des1 && <li>{cardInfo?.des1}</li> } 
                       {cardInfo?.des2 && <li>{cardInfo?.des2}</li> } 
                       {cardInfo?.des3 && <li>{cardInfo?.des3}</li> } 
                       {cardInfo?.des4 && <li>{cardInfo?.des4}</li> } 
                       {cardInfo?.des5 && <li>{cardInfo?.des5}</li> } 
                    
                
                      
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default GalleryImg;